module.exports = __webpack_public_path__ + "img/lock-primary.ab27288c.svg";